module.exports = __webpack_public_path__ + "static/media/image-4.7e670626.jpg";